import styled, { keyframes } from "styled-components";

import { COLOR_ADEGA_BLUE, MOBILE_WIDTH } from "../../config";
import { GREEN_GRADIENT } from "../../styleConfig";

export const MainContainer = styled.div`
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &:hover div {
    width: 15px;
  }
`;

export const Title = styled.h2`
  color: black;
  font-weight: 600;
  font-size: 28px;

  @media (max-width: ${MOBILE_WIDTH}) {
    font-size: 20px;
  }
`;

export const LightTitle = styled.span`
  color: black;
  font-weight: 400;
  font-size: 28px;

  @media (max-width: ${MOBILE_WIDTH}) {
    font-size: 20px;
  }
`;

const bottomBarAnimation = keyframes`
    from {
      width: 0px;
    }
    to {
      width: 150px;
    }
  `;

export const BottomBar = styled.div`
  transition: 0.2s;
  animation: .3s forwards 0s 1 ${bottomBarAnimation};
  ${GREEN_GRADIENT}
  width: 150px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
`;
